import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "@/features/auth/hooks/use-auth-context";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { state } = useAuthContext();
  const location = useLocation();
  if (state.status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-neutral-500">
        読み込み中...
      </div>
    );
  }
  if (state.status === "anonymous") {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  return <>{children}</>;
}
